import React, { useState } from 'react';
import PropTypes from 'prop-types';
import InfoBox, { InfoBoxSpacer } from '../EnhancedGridFeature/InfoBox';
import GridItemName from '../EnhancedGridFeature/GridItemName';
import EditGridItem from '../EnhancedGridFeature/EditGridItem';
import EditExpression from '../EnhancedGridFeature/EditExpression';
import whiteEllipsisIcon from '../../../images/white-menu-icon.svg';
import GlobalDelete from '../EnhancedGridFeature/GlobalDelete';
import GridSort from '../EnhancedGridFeature/GridSort';
import Label from '../EnhancedGridFeature/Label';

import AutocodeLabelsGenerator, {
  ACStandardLabels,
} from '../../autocode/AutocodeLabelsGenerator';

const { toLabelString } = AutocodeLabelsGenerator(ACStandardLabels, null);

const CrosstabMainColumnHeader = props => {
  const {
    singleDeleteOperation,
    cellElementList,
    toggleCheckVal,
    cellIndex,
    columnHeight,
    partsToShow,
    header,
  } = props;
  const [editEnabled] = useState(false);
  const [ibpBox, setIBPBox] = useState([]);

  const getHeaderLabel = (header, fromMenu = false) => {
    let title = '';
    if (header.isColumnLabelUpdated && !fromMenu) {
      title = header.label;
    } else if (header.autocodenode) {
      title = toLabelString(header.autocodenode, partsToShow, fromMenu);
    } else {
      title = `${header.tooltipVal ? header.tooltipVal : header.label}`;
    }
    if (title.includes('error')) {
      title = header.label;
    }
    return title;
  };

  const buildInfoBox = (header, showingFullNames, index) => {
    const ibp = [];
    ibp.push(
      <GridSort
        cellElements={cellElementList}
        cellIndex={index}
        onSort={props.onSort}
        handleSortingOfGrid={props.handleSortingOfGrid}
      />
    );
    if (index > 0) {
      ibp.push(
        <InfoBoxSpacer
          Height="0.1em"
          boxClassName="toolPalette-spacer-row .ibox-spacer-hline"
        />
      );
      if (!showingFullNames || header.isColumnLabelUpdated) {
        ibp.push(
          <GridItemName
            header="Original Name"
            body={getHeaderLabel(header, true)}
            ShowRestoreButton={header.isColumnLabelUpdated}
            restoreGridTitle={props.restoreGridTitle}
            index={index}
            gridType="ColumnsDataGrid"
          />
        );
        ibp.push(
          <InfoBoxSpacer
            Height="1em"
            boxClassName="toolPalette-spacer-row .ibox-spacer-hline"
          />
        );
      }

      ibp.push(
        <EditGridItem
          updateGridTitle={props.updateGridTitle}
          index={index}
          gridType="ColumnsDataGrid"
        />
      );
      ibp.push(
        <EditExpression
          handleEditExpression={props.handleCrosstabEdit}
          index={index}
          gridType="ColumnsDataGrid"
        />
      );
      ibp.push(
        <InfoBoxSpacer
          Height="0.1em"
          boxClassName="toolPalette-spacer-row ibox-spacer-hline"
        />
      );
      ibp.push(
        <GlobalDelete
          label="Clear Column"
          deleteType="single"
          gridType="ColumnsDataGrid"
          type="col"
          infoBox
          index={cellIndex}
          singleDeleteOperation={singleDeleteOperation}
        />
      );
    }
    return ibp;
  };

  const getUpdatePanels = () => {
    if (ibpBox.length === 0) {
      const p = buildInfoBox(header, toggleCheckVal.column, cellIndex);
      setIBPBox(p);
      return p;
    }
    return ibpBox;
  };

  // useEffect(() => {
  // }, []);

  return (
    <div
      id="crosstab-header-column"
      className={
        header.isSelected ? 'c-table--col--selected' : 'c-table-crosstab-col'
      }
      style={{ height: columnHeight }}
    >
      <div
        className="title-crosstab-container"
        style={{ height: columnHeight }}
      >
        {!editEnabled && (
          <div
            className="crosstab-view-header"
            style={{ height: columnHeight }}
          >
            <span
              className="title-crosstab-btn crosstab-column-header"
              disabled={header.disabled}
              title={`${getHeaderLabel(header)} ${
                header.isColumnLabelUpdated ? String.fromCharCode(185) : ''
              }`}
            >
              <Label
                editEnabled={
                  props.updatedTitleIndex === cellIndex &&
                  props.updatedTitleGridType === 'ColumnsDataGrid'
                }
                label={getHeaderLabel(header)}
                toggleLabel={toggleCheckVal.column}
                gridType="ColumnsDataGrid"
                index={cellIndex}
                cols={50}
                minRows={3}
                maxRows={8}
                minHeight="35px"
                maxHeight="auto"
                style={{
                  left: '0px',
                  backgroundColor: '#424E61',
                  color: 'white',
                }}
                isLabelUpdated={header.isColumnLabelUpdated}
                updateCrosstabGridTitleHeader={
                  props.updateCrosstabGridTitleHeader
                }
                updateGridData={props.updateGridData}
                resetSelectedIndex={props.resetSelectedIndex}
                showFootNoteIcon={header.footnotes ? header.footnotes : []}
                crosstabFootNotes={props.crosstabFootNotes}
              />
            </span>
            <span className="crosstab-view-sort-container">
              <div className="c-table-infobox-ellipsis">
                <InfoBox
                  Panels={getUpdatePanels()}
                  Positions={['bottom']}
                  InfoBoxButtonInner={
                    <img
                      className="ibox-ellipsis"
                      src={whiteEllipsisIcon}
                      alt="..."
                    />
                  }
                  Align="end"
                  containerClassName={
                    getHeaderLabel(header).length < 390
                      ? 'ibox-popover-container'
                      : !props.toggleCheckVal.column ||
                        header.isColumnLabelUpdated
                      ? 'ibox-popover-container-longText'
                      : 'ibox-popover-container'
                  }
                />
              </div>
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

CrosstabMainColumnHeader.propTypes = {
  cellElementList: PropTypes.arrayOf(PropTypes.shape({})),
  cellIndex: PropTypes.number,
  header: PropTypes.shape({
    tooltipVal: PropTypes.string,
    isColumnLabelUpdated: PropTypes.bool,
    footnotes: PropTypes.instanceOf(Array),
    disabled: PropTypes.bool,
    isSelected: PropTypes.bool,
    autocodenode: PropTypes.shape({}),
    label: PropTypes.string,
  }),
  partsToShow: PropTypes.shape({}),
  toggleCheckVal: PropTypes.shape({
    column: PropTypes.bool,
  }),
  singleDeleteOperation: PropTypes.func,
  crosstabColumnSort: PropTypes.shape({}),
  handleCrosstabEdit: PropTypes.func,
  crosstabFootNotes: PropTypes.shape({}),
  updateCrosstabGridTitleHeader: PropTypes.func,
  updateGridData: PropTypes.func,
  resetSelectedIndex: PropTypes.func,
  updateGridTitle: PropTypes.func,
  handleSortingOfGrid: PropTypes.func,
  onSort: PropTypes.func,
  updatedTitleIndex: PropTypes.number,
  updatedTitleGridType: PropTypes.string,
  columnHeight: PropTypes.string,
};

export default React.memo(CrosstabMainColumnHeader);
